import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { BreakpointProvider } from 'utils/context/BreakpointContext'
import CoverModal from '../../components/CoverModal'
import { ShipmentIdProvider, useShipmentIdContext } from './context/ShipmentIdContext'

const App: FC = () => {
  const shipmentId = useShipmentIdContext()
  const history = useHistory()

  const closeHandler = () => {
    history.goBack()
  }

  return <CoverModal shipmentId={shipmentId} onClose={closeHandler} />
}

const ShipmentCoverage: FC = () => {
  return (
    <ShipmentIdProvider>
      <BreakpointProvider>
        <App />
      </BreakpointProvider>
    </ShipmentIdProvider>
  )
}
export default ShipmentCoverage
